module.exports = __webpack_public_path__ + "static/media/home_prime_img.7e99f26a.jpg";